import PropTypes from 'prop-types';
import React from 'react';
import { Component as ComponentType } from './types';
import { ComponentStatuses as ComponentStatusesType } from './types';

const cx = require('classnames');

const StatusInput = require('components/manage/pages/components/status_input');

class StatusDropdown extends React.Component {

  static propTypes = {
    component: ComponentType.isRequired,
    componentStatuses: ComponentStatusesType.isRequired,
    currentStatus: PropTypes.string,
    informParent: PropTypes.func,
    isChild: PropTypes.bool,
    isEnabled: PropTypes.bool,
    isGroup: PropTypes.bool,
    shouldAutoUpdate: PropTypes.bool.isRequired,
    updateComponent: PropTypes.func.isRequired,
  };

  static defaultProps = {
    informParent: new Function(),
    isChild: false,
    isEnabled: false,
    isGroup: false,
    currentStatus: 'operational',
  };

  constructor (props) {
    super(props);
    this.state = {
      showDropdown: false,
      currentStatus: this.props.componentStatuses[this.props.currentStatus],
    };
  }

  componentDidMount () {
    HRB.utils.djshook('tooltip').tooltip();
    window.addEventListener('click', this._handlePageClick.bind(this, this.props.component.id));
    window.addEventListener('keydown', this._handleKeyPress.bind(this));
  }

  componentWillReceiveProps (newProps) {
    // Allow Group updates to trickle down, for derived statuses
    if (this.props.isGroup) {
      this.setState({ currentStatus: this.props.componentStatuses[newProps.currentStatus] });
    }

    // If a 3PC is disabled, the based_on_status is used
    if (this.props.component.is_third_party && !newProps.isEnabled) {
      this.setState({ currentStatus: this.props.componentStatuses[newProps.component.based_on_status] });
    }
  }

  _handlePageClick (id, e) {
    // Close the dropdown unless we're clicking on ourselves
    if (!$(e.target).hasClass(id)) {
      this.setState({ showDropdown: false });
    }
  }

  _handleKeyPress (e) {
    // Close the dropdownn on ESC
    if (e.keyCode === 27) {
      this.setState({ showDropdown: false });
    }
  }

  _toggleDropdown = () => {
    if (this.props.isEnabled) {
      this.setState({ showDropdown: !this.state.showDropdown });
    }
  }

  _setNewStatus = (e) => {
    const newName = e.target.textContent;
    const newStatus = Object.values(this.props.componentStatuses).find(entry => entry.name === newName);

    this.setState({ currentStatus: newStatus });
    this._toggleDropdown();

    // Inform the parent of a change if this is a child component
    if (this.props.isChild) {
      this.props.informParent(this.props.component.id, newStatus.label);
    }

    // Send the change to the server if we're on the dashboard
    if (this.props.shouldAutoUpdate) {
      this.props.updateComponent(newStatus.label, newName);
    }
  }

  _tooltipMessage () {
    let message = '';

    if (this.props.isGroup) {
      message = `Based on the status of its children, ${this.props.component.name} is reporting a status of ${this.state.currentStatus.name}.`;
    } else if (this.props.component.is_third_party) {
      message = `${this.props.component.based_on_name} is reporting a status of ${this.state.currentStatus.name}.`;
    }

    return message;
  }

  _currentStatusDisplay () {
    return (
      <div
        className={`component-status-display ${this.props.component.id}`}
        data-js-hook="tooltip"
        data-original-title={this.props.isEnabled ? null : this._tooltipMessage()}
        onClick={this._toggleDropdown}>
        <i className={`fa fa-circle ${this.props.component.id}`} style={{ color: this.state.currentStatus.color }} />
        <span className={`current-status ${this.props.component.id}`}>{this.state.currentStatus.name}</span>
        <span className={`pull-right arrow fa fa-chevron-down ${this.props.component.id}`} />
      </div>
    );
  }

  _dropdownDisplay () {
    if (!this.state.showDropdown || !this.props.isEnabled) { return; }

    const dropdown = [];
    const active = this.state.currentStatus.name;

    Object.keys(this.props.componentStatuses).forEach((key) => {
      const status = this.props.componentStatuses[key];

      if (active !== status.name) {
        dropdown.push(
          <div className="status-option" onClick={this._setNewStatus} key={status.name}>
            <i className="fa fa-circle" style={{ color: status.color }} />
            <span className="status-option-name">{status.name}</span>
          </div>,
        );
      }
    });

    return <div className="status-dropdown">{dropdown}</div>;
  }

  render () {
    let classNames = 'component-dropdown-selector';

    if (!this.props.isEnabled) { classNames = cx(classNames, 'dropdown-inactive'); }
    if (this.state.showDropdown) { classNames = cx(classNames, 'dropdown-open'); }

    return (
      <div className={classNames} data-js-hook="component-status-selector">
        { this._currentStatusDisplay() }
        { this._dropdownDisplay() }
        <StatusInput
          componentParam={this.props.component.id}
          updateStatus={this.state.currentStatus.label}
          shouldReset={!this.props.isEnabled}
          groupOr3pc={this.props.isGroup || this.props.component.is_third_party} />
      </div>
    );
  }
}

module.exports = StatusDropdown;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/status_dropdown.jsx